
import React from 'react';
import { DiagnosticResult } from './types';

interface AssignedBasesSectionProps {
  results: DiagnosticResult;
}

export const AssignedBasesSection: React.FC<AssignedBasesSectionProps> = ({ results }) => {
  return (
    <div className="bg-muted p-4 rounded-md">
      <h3 className="font-medium mb-2">Assigned Bases</h3>
      <div className="text-sm">
        {results.assigned_bases.length > 0 ? (
          <pre className="bg-background p-2 rounded text-xs overflow-auto max-h-24">
            {JSON.stringify(results.assigned_bases, null, 2)}
          </pre>
        ) : (
          <p className="text-red-500">No bases assigned to current user</p>
        )}
      </div>
    </div>
  );
};
